module.exports = __webpack_public_path__ + "img/5ed8a7bf3d521dd24bb099f8c726d6f2.svg";